/**
 * App privilege identifiers. Member **keys** are kept stable for existing
 * call sites; the string **values** follow the canonical `Module.Action`
 * convention (must match `api/src/lib/data/roles.ts`). `isPrivilegedTransaction`
 * compares values case-insensitively.
 */
export enum RoleTypes {
  // Companies
  ViewCompanies = "Companies.View",
  AddCompanies = "Companies.Create",
  CompanyManagement = "Companies.Manage",
  PartnersManagement = "Companies.ManagePartners",

  // Users & access
  ManageUsers = "Users.Manage",
  ManageUserRoles = "Users.AssignRoles",

  // Candidates (browse list + CV)
  ViewCandidates = "Candidates.View",
  ViewCv = "Candidates.ViewCv",
  CvMaker = "Candidates.CvMaker",

  // Employees (list + per-tab read-only views)
  ViewEmployees = "Employees.View",
  Search = "Employees.Search",
  ViewPending = "Employees.ViewPending",
  ViewAvailable = "Employees.ViewAvailable",
  ViewSelected = "Employees.ViewSelected",
  ViewContracted = "Employees.ViewContracted",
  ViewEmbassy = "Employees.ViewEmbassy",
  ViewLabour = "Employees.ViewLabour",
  ViewTicketing = "Employees.ViewTicketing",
  ViewFlightBooked = "Employees.ViewFlightBooked",
  ViewDeparted = "Employees.ViewDeparted",
  ViewDiscontinued = "Employees.ViewDiscontinued",
  ViewStopped = "Employees.ViewStopped",

  // Visas (records)
  ViewVisas = "Visas.View",
  ManageVisas = "Visas.Manage",

  // Process control (pipeline status transitions)
  ChangeEmployeeStatus = "ProcessControl.ManageStatuses",
  SelectCandidates = "ProcessControl.Select",
  DeselectCandidates = "ProcessControl.Deselect",
  ContractEmployees = "ProcessControl.Contract",
  IssueEmployeeVisa = "ProcessControl.IssueVisa",
  IssueEmployeeLabour = "ProcessControl.IssueLabour",
  BookEmployeeTicket = "ProcessControl.BookTicket",
  MarkEmployeeDeparted = "ProcessControl.MarkDeparted",
  ChangeEmployeeDisposition = "ProcessControl.SetDisposition",
  DiscontinueProcess = "ProcessControl.Discontinue",
  StopProcess = "ProcessControl.Stop",

  // Records (data entry: register / employee records / documents)
  RegisterCandidate = "Records.AddNewBasic",
  AddEmployees = "Records.AddNewDetail",
  EditEmployees = "Records.EditEmployee",
  DeleteEmployees = "Records.DeleteEmployee",
  UploadFiles = "Records.UploadFiles",
  AddMedical = "Records.AddMedical",
  AddCoc = "Records.AddCoc",

  // Complaints
  OpenComplains = "Complaints.Open",
  EditComplains = "Complaints.Edit",
  ClosComplains = "Complaints.Close",
  ReOpenComplains = "Complaints.Reopen",
  ConfirmComplains = "Complaints.Confirm",

  // Insights
  ViewDashboard = "Insights.Dashboard",
  ViewReports = "Insights.Reports",

  // Account (self-service)
  CompanyProfile = "Account.CompanyProfile",
  ChangePassword = "Account.ChangePassword",

  // Notifications
  ViewNotifications = "Notifications.View",
  MarkAsReadNotifications = "Notifications.MarkRead",
  DeleteNotifications = "Notifications.Delete",

  // Wall
  ViewWall = "Wall.View",
  PostWall = "Wall.Post",
  ModerateWall = "Wall.Moderate",
}
